import React from 'react'

type SorterDownArrowProps = {
  color?: string;
}

const SorterDownArrow = ({ color }: SorterDownArrowProps) => (
  <svg width="10" height="8" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.98232 5.65875L0.68507 1.88988C0.295945 1.44644 0.612195 0.75 1.20276 0.75H7.79726C7.92943 0.749887 8.05883 0.787873 8.16996 0.859409C8.28109 0.930946 8.36925 1.033 8.42388 1.15335C8.47851 1.2737 8.49728 1.40725 8.47796 1.538C8.45864 1.66875 8.40204 1.79115 8.31495 1.89056L5.0177 5.65806C4.95317 5.73191 4.87358 5.79109 4.7843 5.83164C4.69501 5.87219 4.59807 5.89317 4.50001 5.89317C4.40194 5.89317 4.30501 5.87219 4.21572 5.83164C4.12643 5.79109 4.04685 5.73191 3.98232 5.65806V5.65875Z" fill={color ? color : '#ADB5BD'}/>
  </svg>
)

export default SorterDownArrow